// utilisation ajouter l'attribut canActivate: [AuthGuard], dans la définition des pages à sécuriser. (ne pas oublier d'importer la classe AuthGuard)


import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedMethods } from '../util/sharedMethods-service';


@Injectable()
export class AuthGuard implements CanActivate {


  constructor(private _authService: AuthService, private router: Router, private sharedMethods: SharedMethods) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    /* if (this._authService.isAuthenticated()) {

        return true;

    } */

    // on sauvegarde les permissions qu'il faut pour la page
    this._authService.permissionsToRedirect = next.data.permissions;


    // gestion avec les rôles on verifie si l'utilisateur est déjà connecter
    if (this._authService.token !== undefined && this._authService.token !== null) {

         /* if ( state.url === '/pages/dashboard') {

            this.router.navigate(['/pages/test']);
            return false;

         } else {

            return true;

         } */

        if (next.data.permissions !== undefined) { // il faut avoir le rôle pour accéder à la page

            if ( this._authService.token.user.permissions !== undefined && this._authService.token.user.permissions !== null) { // l'utilisateur  à au moins un rôle

                if ( this._authService.isHavingPermission(next.data.permissions)) {

                    // l'utilisateur possède le rôle
                    return true;

                } else {

                    // this.router.navigate(['/pages/test']); // ATTENTION CETTE ROUTE NE DOIT PAS être protégé par un login sinon on risque d'avoir un boucle infini
                    this.sharedMethods.sweetalert('error', 'Accèss non autorisé', 'Vous n\'avez pas tous les droits nécéssaires pour accéder à cette fonction');
                    return false;

                }

            } else {

                // il faut un rôle pour accéder mais l'utilisateur n'en a aucun
                // this.router.navigate(['/pages/test']); // ATTENTION CETTE ROUTE NE DOIT PAS être protégé par un login sinon on risque d'avoir un boucle infini
                this.sharedMethods.sweetalert('error', 'Accèss non autorisé', 'Vous n\'avez pas tous les droits nécéssaires pour accéder à cette fonction');
                return false;

            }


        } else {

            // aucun rôle n'est néssaire pour acceder à la route
            return true;
        }

    }

    //  l'utilisateur n'est pas déjà connecter
    if (state.url !== '/pages/login')
    this._authService.redirect = state.url;

    // navigate to login page
    this.router.navigate(['/pages/login']);

    // you can save redirect url so after authing we can move them back to the page they requested
    return false;

  }

}
